
import { ref, onMounted, reactive, defineComponent } from 'vue'
import DataTable from '@/views/components/table/HjpDataTable.vue'
import Form from './Form.vue'

export default defineComponent({
  components: {
    DataTable,
    Form
  },
  setup() {
    const tabelParams = reactive({
      endpoint: '/talent/v1/regions',
      headerTitle: 'Master Wilayah',
      buttonTitle: '',
      editTitle: 'Edit',
      deleteTitle: 'Hapus',
      confirmDialogDelete: {
        title: 'Hapus Wilayah?',
        subTitle: 'Data wilayah tersebut akan dihapus dalam sistem. Yakin hapus wilayah?',
        btnSubmitTitle: 'Hapus Wilayah',
      },
      columnsTable: [
        {
          field: 'name',
          headerName: 'Nama Wilayah',
          searchable: true,
          fieldSearch: 'name',
          isRender: false
        },
        {
          field: 'description',
          headerName: 'Keterangan',
          searchable: true,
          fieldSearch: 'description',
          isRender: false
        },
      ]
    })

    const onDeleteFailedMessage = ref({
      summary: 'Gagal menghapus Data Wilayah',
      detail: 'Data Wilayah masih terhubung dengan Data Karyawan. Silahkan periksa Master Karyawan terlebih dahulu.'
    })
    // const slotBank = 'MsBank.Name'
    // const slotChannelBank = 'MsChannelBanks.OaAccount'
    // const getBankChannelId = (data: any) => {
    //   console.log('data', data)
    // }
    return {
      tabelParams,
      onDeleteFailedMessage
    }
  }
})
